import { UserRole } from '@lmc/ts-common'
import { getKeys } from './getKeys'

export const reportingTranslations = {
  DOWNLOAD_CENTRE: 'Download Centre',
  DOWNLOAD: 'Download {{variable}}',
  TEAM_MEMBERS_TITLE: 'Team Members',
  TEAM_MEMBERS_DESC:
    'The report includes information such as Profile details, admission data, current stats and more. You can use this CSV to review specific details across multiple people in one go.',
  RESIDENTS_TITLE: 'Residents',
  RESIDENTS_DESC:
    'This report includes {{variable}} profile information. You can use this CSV to review multiple {{variable2}} details in one go.',
  OUTCOME_GOALS_TITLE: 'Outcomes and Goals',
  OUTCOME_GOALS_DESC:
    'You can find all Outcomes and Goals related information in one place. Use this report to drill deeper into progress achieved across your service.',
  RISK_ASSESSMENTS_TITLE: 'Risk Assessments',
  RISK_ASSESSMENTS_DESC:
    'Explore current and historic Risk Assessments. Uncover trends and common patterns by reviewing risk scores, review dates and other details.',
  CARE_PLANS_TITLE: 'Care Plans',
  CARE_PLANS_DESC:
    'Access current and historic {{variable}}. This information will allow you to review multiple care plan details across your service.',
  EMAR_TITLE: 'eMar',
  EMAR_DESC:
    'Access eMAR related information to better understand what medication a service user has been on, when they started and when it was discontinued.',
  LOGS_TITLE: 'Logs',
  LOGS_DESC:
    'Download all logs in one place. Use this data to drill down into care your service provided overtime.',
  DOWNLOAD_CSV: 'Download CSV',
  SELECT_ENTITY: 'Select {{variable}} to include in CSV',
  SITES: 'Sites',
  SITES_EXTRA: 'Select sites that should be included in the CSV',
  RISK_ASSESSMENT_STATUS: 'Risk Assessment Status',
  CARE_PLANS_STATUS: 'Care Plans Status',
  CURRENT_ONLY: 'Current only',
  LOG_CATEGORY: 'Log Category',
  LOG_ITEMS: 'Log Items',
  ARCHIVED_DATA: 'Archived data',
  ERROR_TRIGGERED: 'Error triggered by ',
  NO_CHANGES: 'No changes recorded.',
  ADDED: 'Added',
  CHANGED: 'Changed',
  REMOVED: 'Removed',
  ARCHIVED_DATA_DESCRIPTION_I: 'To see audit logs older than a month, please ',
  ARCHIVED_DATA_DESCRIPTION_II: 'contact customer support.',
  SELECTED_DATES:
    'Select dates between which the care plans have been originally created',
  CARE_PLANS_CREATED: '{{variable}} created between',
  LOGS_CREATED: 'Logs created between',
  FILTER_BY_USERS: 'Filter by {{variable}} who the log is associated with',
  SELECTED_DATES_logs:
    'Select dates between which the logs have been generated',
  CURRENT_AND_HISTORIC_RECORDS: 'Current and historic records',
  SELECT_TO_INCLUDE:
    'Select to include historic records such as revisions and Risk Assessments not attached to {{variable}}',
  SELECT_TO_INCLUDE_CARE_PLANS:
    'Select to include historic records such as revisions and {{variable}} that require no further support',
  BULK_DOWNLOAD: 'Bulk Download',
  DOWNLOAD_CSVS: 'Download CSVs',
  EMPTY_CSV:
    'Please select data using the filter above. If nothing is selected, the CSV will be empty.',
  EARLY_BANNER_TITLE:
    'Early Access: Discover our new Download Centre and share your feedback',
  EARLY_ACCESS_BUTTON: 'Share your feedback',
  AUDIT_TITLE: 'Audit Trail',
  DATE_TIME: 'Date & time',
  TIMEZONE: '(UTC+2)',
  [UserRole.careHomeAdmin]: 'Admin',
  [UserRole.carer]: 'Carer',
  [UserRole.family]: 'Family Member',
  [UserRole.groupAdmin]: 'Group Admin',
  [UserRole.groupManager]: 'Group Manager',
  [UserRole.lmcAdmin]: 'LMC Admin',
  [UserRole.seniorCarer]: 'Senior Carer',
  EMPTY_STATE_TITLE: 'Shoot... No data to show you',
  EMPTY_STATE_DESCRIPTION: 'No audit logs found',
  AUTHOR: 'Author',
  ROLE: 'Role',
  EVENT: 'Event',
  DETAILS: 'Details',
  TO: 'To',
  FROM: 'From',
  ROS_HISTORY_TITLE: 'Rostering history',
  ROS_HISTORY_DESC:
    'Download comprehensive historical rostering information in one place. Use this data to analyse specific rota details such as actual event durations, time discrepancies, and more.',
  UP_ROTA_TITLE: 'Upcoming rota',
  UP_ROTA_DESC:
    'Download the upcoming rota for future scheduling. This file can be shared outside the Log My Care system as needed.',
  ROTA_EVENTS_CREATED: 'Rota events created between',
  ROTA_SELECT_DATES:
    'Select dates between which the rota events have been generated',
  ROTA_SERVICE_USERS_EXTRA: `Filter by {{variable}} who the rota event is associated with`,
  ROTA_TEAM_MEMBERS_EXTRA: `Filter by Team Members who have been assigned to the rota event`,
  ROTA_CREATED_BY_TITLE: `Created By`,
  ROTA_CREATED_BY_EXTRA: `Filter by Admins who created the rota event`,
  ROTA_EDITED_BY_EXTRA: `Last Edited By`,
  ROTA_EDITED_BY_TITLE: `Filter by Admins who have been last editing the rota event`,
  OUTCOMES_AND_GOALS_CREATED: 'Outcomes and Goals created between',
  OUTCOMES_AND_GOALS_SELECT_DATES:
    'Select dates between which the outcomes and goals have been originally created',
  OUTCOMES_AND_GOAL_STATUS: `Outcomes and Goals Status`,
  OUTCOMES_AND_GOAL_SITES: `Sites`,
  CSV_SHIFTS_INFO:
    'Shifts aren’t linked to specific {{nominativePlural}}, so they won’t show up when you apply {{nominative}} filters.'
}

export const reportingConstants = getKeys(reportingTranslations)
